// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class FullSurveySessionPostRequest {
    static getAttributeTypeMap() {
        return FullSurveySessionPostRequest.attributeTypeMap;
    }
}
FullSurveySessionPostRequest.discriminator = undefined;
FullSurveySessionPostRequest.additionalProperties = false;
FullSurveySessionPostRequest.attributeTypeMap = [
    {
        "name": "sessionValues",
        "baseName": "sessionValues",
        "type": ""
    },
];
//# sourceMappingURL=fullSurveySessionPostRequest.js.map